const getNextHoliday = (year, holidays = [], date, months) => {
    try {
        if (date.getFullYear() !== year || holidays.length === 0) {
            return {};
        }

        const month = date.getMonth();
        const day = date.getDate();
        let dateHoliday = null;

        const nextHoliday = holidays.find((holiday) => {
            try {
                if (holiday.date) {
                    dateHoliday = new Date(holiday.date);
                    return (month === dateHoliday.getMonth() && day < dateHoliday.getDate()) || (month < dateHoliday.getMonth());
                } else {
                    // Entra la api vieja
                    return (month === holiday.month - 1 && day < holiday.day) || (month < holiday.month - 1);
                }
            } catch (findError) {
                console.error('Error in find function:', findError);
                throw findError; // Propagar el error para manejarlo en el bloque catch externo
            }
        });

        // Verificar si nextHoliday está definido y tiene la propiedad 'date'
        if (nextHoliday && nextHoliday.date) {
            dateHoliday = new Date(nextHoliday.date);
        } else if (nextHoliday) {
            // Entra la api vieja
            dateHoliday = new Date(year, nextHoliday.month - 1, nextHoliday.day);
        } else {
            return {}; // No se encontraron próximas vacaciones
        }

        const difference = dateHoliday.getTime() - date.getTime();
        const totalDays = Math.ceil(difference / (1000 * 3600 * 24));

        return {
            totalDays,
            monthName: months[dateHoliday.getMonth()],
            day: dateHoliday.getDate(),
            motive: nextHoliday.motive,
        };
    } catch (error) {
        console.error('Error in getNextHoliday:', error);
        return {}; // Devolver un objeto vacío en caso de error
    }
};

export default getNextHoliday;